import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { RecaptchaTermsAndPolicy, useInvisibleRecaptcha } from '@atlassian/google-recaptcha';

import { type Environment, getEnvironment } from '../../../common/utils/environment';

export const RECAPTCHA_SITE_KEYS: { [env in Environment]: string } = {
	prod: '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru',
	stg: '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3',
	dev: '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ',
};

export const useRecaptcha = () => {
	return useInvisibleRecaptcha({
		siteKey: RECAPTCHA_SITE_KEYS[getEnvironment()],
		displayBadge: false,
		analyticsChannel: 'confluence',
		analyticsSource: 'inviteOnLinkInsert',
	});
};

export const RecaptchaTerms = () => (
	<Box xcss={recaptchaContainerStyles}>
		<RecaptchaTermsAndPolicy />
	</Box>
);

const recaptchaContainerStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: Needs manual remediation
	fontSize: '10px',
	color: 'color.text.subtlest',
	marginTop: 'space.075',
	marginBottom: 'space.050',
});
